module.exports = __webpack_public_path__ + "static/media/激光切割百变灯台.16f9ec96.png";